import { render } from "./OriginatorRewardValue.vue?vue&type=template&id=298f2e23"
import script from "./OriginatorRewardValue.vue?vue&type=script&lang=js"
export * from "./OriginatorRewardValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__